registerGlobal('ApplicationUtils');

ApplicationUtils.GetHardwareKey = function() {
    var generate_guid = function() {
        uuidv4 = require('uuid/v4');
        return uuidv4() + "-" + FB.getUserID();
    };

    var storage = null;
    try { storage = window.localStorage; } catch(e) {}
    storage = storage || ApplicationUtils;

    if (storage.clawHardwareKey == null) {
        var guid = generate_guid();
        try {
            storage.clawHardwareKey = guid;
        }
        catch (_) { // prevent Safari in private mode from crash
            storage = ApplicationUtils;
            storage.clawHardwareKey = guid;
        }
    }

    return storage.clawHardwareKey;
}

ApplicationUtils.PercentEncode = function( str ) {
    return encodeURI( str );
}

ApplicationUtils.GetCurrentURL = function() {
    return window.location.origin + window.location.pathname;
}

ApplicationUtils.GetUserLanguage = function() {
    var ret = null

    // just in case on some exotic browser it throws exception
    try {
        if ( navigator ) {
            if ( navigator.languages ) {
                ret = navigator.languages[0];
            } else {
                ret = navigator.language || navigator.userLanguage;
            }
        }
    } catch (e) {
        // no-op, return english
    }

    return ret || "en"
}

registerGlobal('tabOpen')
tabOpen = function(url) {
    if (document.exitFullscreen) {
        document.exitFullscreen();
    }
    else if (document.msExitFullscreen) {
        document.msExitFullscreen();
    }
    else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    }
    else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
    }
    window.open(url, '_blank');
    window.focus();
}

registerGlobal('setClipboardText');
setClipboardText = function(text) {
    var id = "mycustom-clipboard-textarea-hidden-id";
    var existsTextarea = document.getElementById(id);

    try {
        if (!existsTextarea) {
            var textarea = document.createElement("textarea");
            textarea.id = id;

            // Prevent zooming on iOS
            textarea.style.fontSize = '12pt';

            // Move element out of screen horizontally
            var isRTL = document.documentElement.getAttribute('dir') == 'rtl';
            textarea.style.position = 'absolute';
            textarea.style[isRTL ? 'right' : 'left'] = '-9999px';

            // Move element to the same position vertically
            var yPosition = window.pageYOffset || document.documentElement.scrollTop;
            textarea.style.top = yPosition + 'px';

            // Ensure it has a small width and height. Setting to 1px / 1em
            // doesn't work as this gives a negative w/h on some browsers.
            textarea.style.width = '1px';
            textarea.style.height = '1px';

            // We don't need padding, reducing the size if it does flash render.
            textarea.style.padding = 0;
            textarea.style.margin = 0;

            // Clean up any borders.
            textarea.style.border = 'none';
            textarea.style.outline = 'none';
            textarea.style.boxShadow = 'none';

            // Avoid flash of white box if rendered for any reason.
            textarea.style.background = 'transparent';
            textarea.setAttribute('readonly', '');
            document.querySelector("body").appendChild(textarea);

            existsTextarea = document.getElementById(id);
        }

        existsTextarea.value = text;
        existsTextarea.select();
        existsTextarea.setSelectionRange(0, existsTextarea.value.length);

        var status = document.execCommand('copy');
        if (!status) {
            throw "status error";
        }
    }
    catch (err) {
        window.prompt("Copy to clipboard: press Ctrl+C / Command+C, Enter", text);
    }
}

registerGlobal('serializeForm');
serializeForm = function(formID) {
    var form = document.getElementById(formID);
    var json = [];
    // Loop through all the form elements
    for (var i = 0; i < form.length; i++) {
        // Make sure they're valid to be stored (i.e. checked, not a button)
        if (form.elements[i].name && (form.elements[i].checked ||
                /select|textarea/i.test(form.elements[i].nodeName) ||
                /text|password/i.test(form.elements[i].type))) {
            // Store them in an object association
            var entry = {};
            entry[form.elements[i].name] = form.elements[i].value;
            json.push(entry);
            //alert(form.elements[i].id+": "+form.elements[i].value);
        }
    }
    CookieUtils.setCookie(formID, JSON.stringify(json), 999);
}

registerGlobal('createPrintFunction');
createPrintFunction = function() {
    var element = document.getElementById('output');
    var addText = "";
    if (element) element.value = ''; // clear browser cache
    return function(text) {
        if (arguments.length > 1) text = Array.prototype.slice.call(arguments).join(' ');
        // These replacements are necessary if you render to raw HTML
        //text = text.replace(/&/g, "&amp;");
        //text = text.replace(/</g, "&lt;");
        //text = text.replace(/>/g, "&gt;");
        //text = text.replace('\n', '<br>', 'g');
        console.log(text);

        if (element) {
            addText += text + "\n";
            window.setTimeout(function()
            {
                if (addText === "") return;
                element.value += addText;
                addText = "";
                element.scrollTop = element.scrollHeight; // focus on bottom
            }, 10);
        }
    };
};

//------------------------------
//set mode
var appMode = appMode;



//////////////////
// WEBPACK FOOTER
// /src/claw/sdk/src/claw/system/emscripten/Application.utils.js
// module id = 12
// module chunks = 0